//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconAlertTriangleFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0.25 21H23.75L12 1.03003L0.25 21ZM12 17.75C11.31 17.75 10.75 17.19 10.75 16.5C10.75 15.81 11.31 15.25 12 15.25C12.69 15.25 13.25 15.81 13.25 16.5C13.25 17.19 12.69 17.75 12 17.75ZM13 14H11V9.00003H13V14Z" fill="currentColor" /></svg>;
}
export default IconAlertTriangleFill;